import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import WhyUsSection from './components/WhyUsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOMeta
        title="喷水系统专业解决方案——高效喷水设备选购指南"
        description="专业喷水系统全面指南，涵盖喷水设备类型、喷水技术原理、安装维护要点及选购建议。无论农业灌溉、景观喷水还是工业冷却，我们提供最权威的喷水方案，帮助您降低成本、提升效率，找到最适合的喷水产品。"
        keywords="喷水,喷水系统选购,喷水设备类型,农业喷水灌溉,景观喷水装置,工业喷水冷却,喷水安装维护"
        canonicalUrl="https://www.penshuixitong.cn/"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '喷水系统专业解决方案',
            url: 'https://www.penshuixitong.cn/',
            description: '专业喷水系统全面指南，涵盖喷水设备类型、喷水技术原理、安装维护要点及选购建议。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.penshuixitong.cn/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '喷水系统专业解决方案',
            url: 'https://www.penshuixitong.cn/',
            description: '专注喷水系统领域，提供农业灌溉、景观喷水、工业冷却等全方位喷水解决方案。',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-888-9999',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <WhyUsSection />
        <FAQSection />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}